export class NodeModel {
    id: number;
    name: string;
    selectable: boolean;
    code: string;
    children: NodeModel[];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/tree/model/NodeModel.ts